import {Pattern} from 'app/modules/core'
import {FC, FocusEvent, KeyboardEvent, useEffect, useState} from 'react'

type Props = {
  name?: string
  value?: number | string
  maxLength?: number
  placeholder?: string
  className?: string
  handleChange?: (e: React.ChangeEvent<HTMLInputElement>) => void
  handleBlur?:(e:any)=> void
  disabled?: boolean
  pattern?: RegExp
}

const InputNumber: FC<Props> = (props) => {
  const {
    value = '0',
    maxLength = 10,
    placeholder = '',
    className = 'form-control form-control-lg',
    handleChange,
    pattern = Pattern.Number,
  } = props

  const [val, setVal] = useState(value)
  useEffect(() => {
    const init = () => {
      if (props.value) setVal(props.value.toString())
    }
    init()
  }, [props.value])

  const handleOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (pattern.test(e.target.value)) {
      setVal(e.target.value)
      handleChange?.(e)
    } else {
      return
    }
  }

  const handleBlur = (e: FocusEvent<HTMLInputElement, Element>) => {
    if (e.target.value === '') setVal('0')
    props.handleBlur?.(e)
  }

  return (
    <>
      <input
        name={props.name}
        type='text'
        maxLength={maxLength}
        onChange={(e) => handleOnChange(e)}
        onBlur={(e) => handleBlur(e)}
        className={`text-end ${className}`}
        placeholder={placeholder}
        value={val}
        disabled={props.disabled}
        onFocus={(e) => e.target.select()}
      />
    </>
  )
}

export default InputNumber
